<script setup>

import { ref, defineProps } from 'vue';

const props = defineProps({
    highlightedPost: {
        type: Object,
        default: () => ({})
    }
})

const highlightedPost = ref(props.highlightedPost);

const tags = [];

['programmes', 'themes', 'phases'].forEach((key) => {
    if (highlightedPost.value[key]) {
        tags.push(...highlightedPost.value[key]);
    }
});

</script>

<template>
    <section class="section m-billboard m-billboard--articles">
        <div class="m-billboard__images">
            <div class="m-billboard__image m-billboard__image--article">
                <img :src="highlightedPost.card_img.sizes.huge" :alt="highlightedPost.title" />
            </div>
        </div>

        <div class="m-billboard__text">
            <div class="c-heading-text-links">
                <h2 class="c-heading">
                    {{ highlightedPost.title }}
                </h2>

                <div class="c-card-page__tags">
                    <div v-for="tag in tags" :key="tag">
                        <span v-if="tag" class="c-card-page__tag c-card-page__tag--article">{{ tag }}</span>
                    </div>
                </div>

                <div class="c-paragraphs">
                    {{ highlightedPost.intro }}
                </div>

                <a :href="highlightedPost.url" class="btn btn-primary btn-black m-billboard__button">
                    <span>Lees meer</span>
                    <svg class="icon icon-arrow-right"><use xlink:href="#icon-arrow-right"></use></svg>
                </a>
            </div>
        </div>
    </section>
</template>